const EducationData = [
    {
        heading: "Bachelor of Computer Application",
        timespan: "2021 - 2023",
        title: "MJPRU, Bareilly, Uttar Pradesh",
    },
    {
        heading: "Senior Secondary, Science",
        timespan: "Year of Completion - 2021",
        title: "Kendriya Vidyalaya No.2 O.C.F Shahjahanpur, Uttar Pradesh",
    }, {
        heading: "Secondary",
        timespan: "Year of Completion - 2019",
        title: "Kendriya Vidyalaya No.2 O.C.F Shahjahanpur, Uttar Pradesh",
    }
];
export default EducationData;